import React from "react"
import "./EmptyState.style.scss"

interface EmptyStateProps {
  title: string
  description?: string
}

const EmptyState = ({ title, description }: EmptyStateProps) => (
  <div className="learner-empty-state">
    <p className="learner-empty-state__title">{title}</p>
    {description && (
      <p className="learner-empty-state__description">{description}</p>
    )}
  </div>
)

export default EmptyState
